import { ErrorMessage } from 'formik';
import React from 'react';
import { Col, ControlLabel, FormControl, FormGroup, Grid, Row, Label } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PasswordInput from '../CustomControls/CustomPassword';
import { FormErrorMessage } from '../Validations/FormValidationErrors';

export const SignatureFrom = props => {

    const {
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        currentUser
    } = props;

    const { t } = useTranslation();

    return (
        <form onSubmit={handleSubmit} autoComplete="off">
            <FormGroup>
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <ControlLabel>{t("signature.user")}</ControlLabel>
                            <FormControl.Static>{currentUser}</FormControl.Static>
                        </Col>
                        <Col sm={6}>
                            <ControlLabel>{t("signature.password")}</ControlLabel>
                            <PasswordInput name="password" onChange={setFieldValue} onBlur={setFieldTouched} />
                            <ErrorMessage name="password" component={FormErrorMessage} />
                        </Col>
                    </Row>
                </Grid>
            </FormGroup>

            <button type="submit" className="btn btn-success btn-right" >{t("buttons.send")}</button>
            <div className="clearfix"></div>
        </form>
    );
}

export const CreateOrUpdatePasswordForm = props => {

    const {
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        currentUser
    } = props;

    const { t } = useTranslation();

    return (
        <form onSubmit={handleSubmit} autoComplete="off">
            <FormGroup>
                <Grid fluid>
                    <Row>
                        <Col sm={6}>
                            <ControlLabel>{t("signature.createUpdatePassword")}</ControlLabel>
                            <PasswordInput name="newSignaturePassword" onChange={setFieldValue} onBlur={setFieldTouched} />
                            <ErrorMessage name="newSignaturePassword" component={FormErrorMessage} />
                        </Col>
                    </Row>
                </Grid>
            </FormGroup>

            <button type="submit" className="btn btn-success btn-right" >{t("buttons.send")}</button>
            <div className="clearfix"></div>
        </form>
    );
}